<template>
  <div :class="{'font-bold flex justify-center items-center h-8 w-8 rounded text-grey': true, 'bg-green text-white': number > 0}">
    {{number}}
  </div>
</template>
<script>
export default {
  props: {
    number: {
      type: Number,
      default () {
        return 0
      },
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/TableComponents/ActiveApps.vue